<template>
  <div class="login-page" style="background-size: cover;"
    :style="{ 'background-image': 'url(' + require(`../assets/images/login/${businessBack}`) + ')' }">
    <v-container>
      <v-layout row class="mt-10 d-flex justify-center" >
        <v-flex col-md-8 col-sm-12 style="width: 569px;">
          <div class="login-form">
            <h1 class="mb-5">Activación de su <span style="color: rgb(55 152 211);">aplicación</span></h1>
            <v-alert border="left" v-if="error" dense color="orange" type="info">{{ error }}</v-alert>
            <v-form ref="form" class="mx-2 my-2" @submit.prevent="login">
              <v-text-field v-model="username" @input="convertToLowerCase" dense filled outlined label="Correo electrónico" placeholder="Correo electrónico" @keyup.enter="login"
                required :rules="[emailRule]"></v-text-field>
              <password-field  
                outlined
                dense
                v-model="password"
                label="Clave de activación"
                filled
                required
                :rules="[passRule]"
                @keyup.enter="login">
              </password-field>
              <v-btn class="btnsave my-2" type="submit">Activar aplicación</v-btn>
            </v-form>
            <div style="display: flex;justify-content: space-between; align-items: center;" class="logos-container">
              <img :src="require('../assets/images/logo/muchiwa.png')" alt="logo" width="60px" />
              <img :src="require(`../assets/images/logo/${businessLogo}`)" alt="logo" width="320px" />
              <img :src="require('../assets/images/logo/InnovaLogo.png')" alt="logo" width="100px" />
            </div>
          </div>
        </v-flex>

      </v-layout>

    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import PasswordField from '../components/PasswordField.vue';

export default {
  name: "LoginMaster",
  components: { PasswordField },
  data() {
    return {
      username: '',
      password: '',
      error: '',
      businessBack: process.env.VUE_APP_BUSINESS_BACK,
      businessLogo: process.env.VUE_APP_BUSINESS_LOGO,
      emailRule: (value) => {
        if (!value) return 'Correo electrónico: es requerido';
        const reg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return reg.test(value) || "Correo electrónico inválido.";
      },
      passRule: (value)=>{
        if (!value) return 'Clave: es requerida para la activacion';
        return true;
      }
    }
  },
  computed: {
    greeting() {
      return `Welcome, ${this.username || 'guest'}!`
    }
  },
  methods: {
    clearCookies: function(){
      console.info('Clear cookies');
      const domain = window.location.hostname;
      this.$cookies.remove('frontendUrl', '/', domain);
      this.$cookies.remove('BackendUrl', '/', domain);
      this.$cookies.remove('tokenMaster', '/', domain);
      
    },
    convertToLowerCase() {
      this.username = this.username.toLowerCase()
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    async login() {
      const valid = this.$refs.form ? this.$refs.form.validate() : true;
      if (!valid) {
        this.error = 'Por favor corrija los errores del formilario.'
        return;
      }
      if (this.username && this.password) {
        try {
          const paramsAuth = {
            username: (this.username).toString().trim(),
            password: (this.password).toString().trim(),
            businessType: process.env.VUE_APP_BUSINESS_TYPE
          }
          const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/loginmaster`, paramsAuth, 
          {
            headers: {
              'Content-Type': 'application/json',
              'User-Agent': window.navigator.userAgent
            }
          });

          this.error = ''
          //let BusinessName = response.data[0].BusinessName -> en JS los "let" estan hechos para varaiables que cambian de valor, si no deben utilizarse los "const"
          const { FrontendUrl, token } = response.data;

          //Creando cookies
          //this.$cookies.set('BusinessName', BusinessName, { domain: response.data[0].FrontendUrl } )
          //this.$cookies.set('BackendUrl', BackendUrl, { domain: response.data[0].FrontendUrl })
          //this.$cookies.set('ID_KeyMaster', '[ "'+ ID_KeyMaster+ '" ]', { domain: response.data[0].FrontendUrl })

          console.log(`FRONTEND URL: ${FrontendUrl}`)

          
          // Verifica el estado de servicio de una url frontend en base a si se consigue la imagen /public/images/ping.png
          // por lo cual no se debe borrar dicha imagen.
          
          this.verifyDomainWithImage(
            FrontendUrl, 
            (res) => {
              if (res) {
                this.redirectToFrontend(FrontendUrl, token);
              } else {
                this.error = `No se pudo realizar la activación en estos momentos. Por favor, intente mas tarde o comuníquese con el Contact Center ([frontend]: ${FrontendUrl}).`;
              }
            }
          )
        }
        catch (error) {
          console.log('ERROR');
          console.log(error);
          this.error = 'Autenticación fallida, por favor verifique sus credenciales.';
        }
      } else {
        this.error = 'Por favor ingrese usuario y contraseña.'
      }
    },

    verifyDomainWithImage(url, callback) {
      const img = new Image();
      const timeout = setTimeout(() => {
        img.src = '';
        callback(false);
      }, 5000);
      
      img.onload = img.onerror = function() {
        clearTimeout(timeout);
        
        console.log('ping img size')
        console.log(img.width)
        console.log(img.height)

        if (img && img.width > 0 && img.height > 0) {
          callback(true);
        } else {
          callback(false);
        }
      };

      img.src = url + '/images/ping.png?' + Date.now();

    },

    redirectToFrontend(url, token) {
      const now = new Date();
      now.setFullYear(now.getFullYear() + 1);
      document.cookie = `frontendUrl=${url};expires=${now.toUTCString()};domain=${window.location.hostname};path=/`;

      window.location.href = `${url}/#/login?token=${token}`
    },
    clearAllCookies() {
        const cookieNames = ['frontendUrl', 'BackendUrl', 'tokenMaster'];
        
        cookieNames.forEach(name => {
            this.deleteCookie(name);
        });
        
        console.info('Clear all cookies');
    },
    deleteCookie(name, path = '/') {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        const baseDomain = parts.length > 2 ? parts.slice(-2).join('.') : hostname;
        
        
        const domains = [
            hostname,                   
            `.${hostname}`,             
            `tu.${baseDomain}`,
            `.tu.${baseDomain}`,
            baseDomain,                 
            `.${baseDomain}`
        ];
        domains.forEach(domain => {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=${path}; SameSite=None; Secure`;
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=None; Secure`;
        });
        
        console.log(`Clear cookie: ${name}`);
    }

  }
}
</script>

<style scoped>
.login-form {
  background-color: white;
  padding: 40px 20px;
  border-radius: 12px;
  border-top: 12px solid rgb(55 152 211);
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
}

.logos-container {
 
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 20px;
}
.login-page {
  background-color: whitesmoke;
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
}


.error {
  color: red;
}
</style>